import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllEstoqueUseCase } from "../../../presentation/useCases/read/get_all_estoque_use_case";
import { EntradaProdutosFilter } from "../../models/emtrada_produtos_filter";
import { EntradaProduto } from "../../models/entrada_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class GetAllEstoqueUseCase
  extends BasePaginatedUseCase<EntradaProduto>
  implements IGetAllEstoqueUseCase {
  constructor(private readonly repository: IEstoqueRepository) {
    super();
  }

  async getAllListagemEstoque(
    filter: EntradaProdutosFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {

    const response = await this.repository
      .getAllListagemEstoque(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
